import { gql } from '@apollo/client';

export const CREATE_NEW_MATERIAL = gql`
  mutation CreateMaterial($input: NewMaterial!) {
    createMaterial(input: $input) {
      id
      materialId
      name
      measureTypeIDs
      codificationIDs
      subCodificationIDs
      teamIDs
    }
  }
`;

// Materiales por equipo (2026-07-31). Mutation deliberadamente estrecha: solo
// escribe `teamIDs`. El backend hace merge tenant-aware, así que un material
// GLOBAL compartido entre tenants no pierde las asignaciones de los demás.
export const SET_MATERIAL_TEAMS = gql`
  mutation SetMaterialTeams($materialId: ID!, $teamIds: [ID!]!) {
    setMaterialTeams(materialId: $materialId, teamIds: $teamIds) {
      id
      teamIDs
    }
  }
`;

/**
 * Baja lógica del catálogo de materiales (2026-08-31).
 *
 * El material deja de ofrecerse al registrar una actuación, pero se sigue
 * viendo en las que ya lo usan y en los informes históricos. No hay borrado
 * duro: un material usado no se puede borrar sin dejar huérfanas las
 * actuaciones que lo registran.
 */
export const DEACTIVATE_MATERIAL = gql`
  mutation deactivateMaterial($id: ID!) {
    deactivateMaterial(id: $id) {
      id
      isActive
    }
  }
`;

export const ACTIVATE_MATERIAL = gql`
  mutation activateMaterial($id: ID!) {
    activateMaterial(id: $id) {
      id
      isActive
    }
  }
`;
